var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-data-report-status"},[_c('Loading'),_c('p',[_vm._v("Gerando relátorio dos dias ("+_vm._s(_vm.counterPercentage)+")")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }